<section class="block">
  <h2 class="card-title">
    {{ isCorporation() ? 'Ex-acionistas' : 'Ex-sócios' }}
    <span class="count">{{ holders().length }}</span>
  </h2>
  @if (holders().length === 0) {
    <p class="empty">
      Ninguém saiu do quadro nos atos lidos. Quem aparece em ato anterior e não está no vigente
      entra aqui, com o ato em que saiu.
    </p>
  } @else {
    <ul class="people">
      @for (row of holders(); track row.holder.personId) {
        @let open = expanded().has(row.holder.personId);
        <li>
          <div class="person">
            <div class="person__main">
              <span class="person__name">{{ row.holder.name }}</span>
              <app-charter-person-document
                [personId]="row.holder.personId"
                [masked]="row.holder.documentMasked"
                [canReveal]="row.holder.canRevealDocument"
                [personKind]="row.holder.personKind" />
              @if (row.last; as last) {
                <small class="person__exit">
                  {{ last.exited ? 'saiu na' : 'listado até' }}
                  {{ last.provenance.actLabel || 'ato anterior' }}
                  @if (last.provenance.actDate) {
                    ({{ last.provenance.actDate | vaultDate }})
                  }
                </small>
              }
            </div>
            <div class="person__side">
              @if (row.lastValues) {
                <span class="person__values">última posição: {{ row.lastValues }}</span>
              }
              @if (row.last; as last) {
                <app-charter-provenance [from]="last.provenance" />
              }
              @if (row.history.length > 0) {
                <button
                  type="button"
                  class="link-btn"
                  [attr.aria-expanded]="open"
                  (click)="toggle(row.holder.personId)">
                  <i
                    class="pi"
                    [class.pi-history]="!open"
                    [class.pi-chevron-up]="open"
                    aria-hidden="true"></i>
                  {{ open ? 'Fechar' : 'Histórico (' + row.history.length + ')' }}
                </button>
              }
            </div>
          </div>
          @if (open) {
            <app-charter-history-list
              class="history"
              [rows]="row.history"
              [label]="'Histórico de ' + row.holder.name" />
          }
        </li>
      }
    </ul>
  }
</section>

<section class="block">
  <h2 class="card-title">
    Ex-administradores
    <span class="count">{{ formerAdministrators().length }}</span>
  </h2>
  @if (formerAdministrators().length === 0) {
    <p class="empty">Ninguém deixou a administração nos atos lidos.</p>
  } @else {
    <ul class="people">
      @for (admin of formerAdministrators(); track admin.personId) {
        <li>
          <app-charter-administrator-item
            [admin]="admin"
            [isCorporation]="isCorporation()"
            [former]="true"
            [showBody]="true" />
        </li>
      }
    </ul>
  }
</section>
